module.exports = __webpack_public_path__ + "static/media/xiaomi_battery_1.9be8fb64.jpg";